import { render, staticRenderFns } from "./ModalCertificateExample.vue?vue&type=template&id=25651766&scoped=true&"
import script from "./ModalCertificateExample.vue?vue&type=script&lang=js&"
export * from "./ModalCertificateExample.vue?vue&type=script&lang=js&"
import style0 from "./ModalCertificateExample.vue?vue&type=style&index=0&id=25651766&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25651766",
  null
  
)

export default component.exports